"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ApplicationApi extends runtime.BaseAPI {
    /**
     * Accept the application agreement
     */
    acceptAgreementRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/agreements`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Accept the application agreement
     */
    acceptAgreement() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.acceptAgreementRaw();
        });
    }
    /**
     * Get the current application
     */
    getApplicationRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ApplicationFromJSON(jsonValue));
        });
    }
    /**
     * Get the current application
     */
    getApplication() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getApplicationRaw();
            return yield response.value();
        });
    }
    /**
     * Join sweep program
     */
    joinSweepProgramRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/programs/sweeps`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Join sweep program
     */
    joinSweepProgram() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.joinSweepProgramRaw();
        });
    }
    /**
     * Leave sweep program
     */
    leaveSweepProgramRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/programs/sweeps`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Leave sweep program
     */
    leaveSweepProgram() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.leaveSweepProgramRaw();
        });
    }
    /**
     * Remove the applicant\'s trusted contact person
     */
    removeTrustedContactPersonRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/trusted-contact-persons`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove the applicant\'s trusted contact person
     */
    removeTrustedContactPerson() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.removeTrustedContactPersonRaw();
        });
    }
    /**
     * Set the applicant\'s address
     */
    setAddressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setAddress === null || requestParameters.setAddress === undefined) {
                throw new runtime.RequiredError('setAddress', 'Required parameter requestParameters.setAddress was null or undefined when calling setAddress.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/addresses`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetAddressToJSON(requestParameters.setAddress),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s address
     */
    setAddress(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setAddressRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s affiliations
     */
    setAffiliationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setAffiliation === null || requestParameters.setAffiliation === undefined) {
                throw new runtime.RequiredError('setAffiliation', 'Required parameter requestParameters.setAffiliation was null or undefined when calling setAffiliation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/affiliations`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetAffiliationToJSON(requestParameters.setAffiliation),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s affiliations
     */
    setAffiliation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setAffiliationRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s citizenship
     */
    setCitizenshipRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setCitizenship === null || requestParameters.setCitizenship === undefined) {
                throw new runtime.RequiredError('setCitizenship', 'Required parameter requestParameters.setCitizenship was null or undefined when calling setCitizenship.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/citizenships`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetCitizenshipToJSON(requestParameters.setCitizenship),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s citizenship
     */
    setCitizenship(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setCitizenshipRaw(requestParameters);
        });
    }
    /**
     * Set whether the applicant is a control person of a publicly traded company (Director, Officer, or 10% Stock Owner)
     * Set whether the applicant is a control person
     */
    setControlPersonRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setControlPerson === null || requestParameters.setControlPerson === undefined) {
                throw new runtime.RequiredError('setControlPerson', 'Required parameter requestParameters.setControlPerson was null or undefined when calling setControlPerson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/control-persons`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetControlPersonToJSON(requestParameters.setControlPerson),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set whether the applicant is a control person of a publicly traded company (Director, Officer, or 10% Stock Owner)
     * Set whether the applicant is a control person
     */
    setControlPerson(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setControlPersonRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s date of birth
     */
    setDateOfBirthRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setDateOfBirth === null || requestParameters.setDateOfBirth === undefined) {
                throw new runtime.RequiredError('setDateOfBirth', 'Required parameter requestParameters.setDateOfBirth was null or undefined when calling setDateOfBirth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/date-of-births`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetDateOfBirthToJSON(requestParameters.setDateOfBirth),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s date of birth
     */
    setDateOfBirth(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setDateOfBirthRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s employment status
     */
    setEmploymentRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setEmployment === null || requestParameters.setEmployment === undefined) {
                throw new runtime.RequiredError('setEmployment', 'Required parameter requestParameters.setEmployment was null or undefined when calling setEmployment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/employments`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetEmploymentToJSON(requestParameters.setEmployment),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s employment status
     */
    setEmployment(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setEmploymentRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s financial situation
     */
    setFinancialSituationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setFinancialSituation === null || requestParameters.setFinancialSituation === undefined) {
                throw new runtime.RequiredError('setFinancialSituation', 'Required parameter requestParameters.setFinancialSituation was null or undefined when calling setFinancialSituation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/financial-situations`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetFinancialSituationToJSON(requestParameters.setFinancialSituation),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s financial situation
     */
    setFinancialSituation(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setFinancialSituationRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s investment profile
     */
    setInvestmentProfileRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setInvestmentProfile === null || requestParameters.setInvestmentProfile === undefined) {
                throw new runtime.RequiredError('setInvestmentProfile', 'Required parameter requestParameters.setInvestmentProfile was null or undefined when calling setInvestmentProfile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/investment-profiles`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetInvestmentProfileToJSON(requestParameters.setInvestmentProfile),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s investment profile
     */
    setInvestmentProfile(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setInvestmentProfileRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s name
     */
    setNameRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setName === null || requestParameters.setName === undefined) {
                throw new runtime.RequiredError('setName', 'Required parameter requestParameters.setName was null or undefined when calling setName.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/names`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetNameToJSON(requestParameters.setName),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s name
     */
    setName(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setNameRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s phone number
     */
    setPhoneNumberRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setPhoneNumber === null || requestParameters.setPhoneNumber === undefined) {
                throw new runtime.RequiredError('setPhoneNumber', 'Required parameter requestParameters.setPhoneNumber was null or undefined when calling setPhoneNumber.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/phone-numbers`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetPhoneNumberToJSON(requestParameters.setPhoneNumber),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s phone number
     */
    setPhoneNumber(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setPhoneNumberRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s political exposure
     */
    setPoliticalExposureRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setPoliticalExposure === null || requestParameters.setPoliticalExposure === undefined) {
                throw new runtime.RequiredError('setPoliticalExposure', 'Required parameter requestParameters.setPoliticalExposure was null or undefined when calling setPoliticalExposure.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/political-exposures`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetPoliticalExposureToJSON(requestParameters.setPoliticalExposure),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s political exposure
     */
    setPoliticalExposure(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setPoliticalExposureRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s SSN or Tax ID
     */
    setSocialSecurityNumberRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setSocialSecurityNumber === null || requestParameters.setSocialSecurityNumber === undefined) {
                throw new runtime.RequiredError('setSocialSecurityNumber', 'Required parameter requestParameters.setSocialSecurityNumber was null or undefined when calling setSocialSecurityNumber.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/ssns`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetSocialSecurityNumberToJSON(requestParameters.setSocialSecurityNumber),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s SSN or Tax ID
     */
    setSocialSecurityNumber(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setSocialSecurityNumberRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s suitability
     */
    setSuitabilityRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setSuitability === null || requestParameters.setSuitability === undefined) {
                throw new runtime.RequiredError('setSuitability', 'Required parameter requestParameters.setSuitability was null or undefined when calling setSuitability.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/suitabilities`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetSuitabilityToJSON(requestParameters.setSuitability),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s suitability
     */
    setSuitability(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setSuitabilityRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s tax status
     */
    setTaxStatusRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setTaxStatus === null || requestParameters.setTaxStatus === undefined) {
                throw new runtime.RequiredError('setTaxStatus', 'Required parameter requestParameters.setTaxStatus was null or undefined when calling setTaxStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/tax-statuses`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetTaxStatusToJSON(requestParameters.setTaxStatus),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s tax status
     */
    setTaxStatus(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setTaxStatusRaw(requestParameters);
        });
    }
    /**
     * Set the applicant\'s trusted contact person
     */
    setTrustedContactPersonRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.setTrustedContactPerson === null || requestParameters.setTrustedContactPerson === undefined) {
                throw new runtime.RequiredError('setTrustedContactPerson', 'Required parameter requestParameters.setTrustedContactPerson was null or undefined when calling setTrustedContactPerson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/trusted-contact-persons`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SetTrustedContactPersonToJSON(requestParameters.setTrustedContactPerson),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set the applicant\'s trusted contact person
     */
    setTrustedContactPerson(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setTrustedContactPersonRaw(requestParameters);
        });
    }
    /**
     * Sign the application
     */
    signApplicationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.signApplication === null || requestParameters.signApplication === undefined) {
                throw new runtime.RequiredError('signApplication', 'Required parameter requestParameters.signApplication was null or undefined when calling signApplication.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/signatures`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SignApplicationToJSON(requestParameters.signApplication),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Sign the application
     */
    signApplication(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.signApplicationRaw(requestParameters);
        });
    }
    /**
     * Starts a new application
     */
    startApplicationRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/applications`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Starts a new application
     */
    startApplication() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.startApplicationRaw();
        });
    }
    /**
     * Submits the application for approval
     */
    submitApplicationRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/applications/submissions`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Submits the application for approval
     */
    submitApplication() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.submitApplicationRaw();
        });
    }
}
exports.ApplicationApi = ApplicationApi;
